/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

/* ====================================================================
   BEHAVIOURS —> SEARCH
   ==================================================================== */

const readMore = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'readMore',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    expandClipped(e) {
      this.node.classList.add('is-open');
      this.btn.style.display = 'none';
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */
      /**
       * Expose the behaviour object for debugging
       */
      // console.log(this.name + ':', this);

      this.btn = this.getChild('btn');
      this.clippedText = this.getChild('clipped');

      this.panel = this.node;
    },
    enabled() {
      /**
       * The behaviour has been enabled; functions, variable overwrites
       * etc. can be called here
       * All functions, variables etc. are accessible through `this
       */
      // this.logEnabled();

      this.btn.addEventListener('click', this.expandClipped);
    },
  },
);

export default readMore;
